import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import {
    Typography,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Divider,
    Slide,
    Button,
    CircularProgress,
    Box
} from '@mui/material';

const useStyles = makeStyles((theme) => ({
    cancelar: {
        color: theme.palette.btn.red,
        '&:hover': {
            backgroundColor: theme.palette.btn.red,
            color: theme.palette.btn.white
        }
    },
    aceptar: {
        color: theme.palette.btn.green,
        '&:hover': {
            backgroundColor: theme.palette.btn.green,
            color: theme.palette.btn.white
        }
    },
    normal: {
        color: theme.palette.btn.blue,
        '&:hover': {
            backgroundColor: theme.palette.btn.blue,
            color: theme.palette.btn.white
        }
    },
    // Overlay oscuro que cubre todo el Dialog
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        borderRadius: 'inherit'
    }
}));

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const AvisoConfirmacion = ({ open, title, text, accept, cancel, textAcept, textCancel, loading, ...props }) => {
    const classes = useStyles();
    const [textoAceptar, setTextoAceptar] = useState('Aceptar');
    const [textoCancelar, setTextoCancelar] = useState('Cancelar');

    useEffect(() => {
        if (textAcept != null && textCancel != null) {
            setTextoAceptar(textAcept);
            setTextoCancelar(textCancel);
        }
    }, [textAcept, textCancel]);

    return (
        <div>
            <Dialog
                id="avisoConfirmacion"
                sx={{ zIndex: 5000 }}
                open={open}
                TransitionComponent={Transition}
                // Evita cerrar al hacer click fuera mientras carga
                disableEscapeKeyDown={loading}
                onClose={loading ? undefined : cancel}
                PaperProps={{ style: { position: 'relative', overflow: 'hidden' } }}
            >
                {/* Overlay de carga */}
                {loading && (
                    <Box className={classes.overlay}>
                        <CircularProgress size={48} sx={{ color: '#fff' }} />
                    </Box>
                )}

                <form>
                    <DialogTitle>
                        <Typography variant="title">{title}</Typography>
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <DialogContentText>
                            <Typography variant="menuTitle">{text}</Typography>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            id="btnCancelar"
                            className={textCancel != null ? classes.normal : classes.cancelar}
                            onClick={cancel}
                            disabled={loading}
                        >
                            {textoCancelar}
                        </Button>
                        <Button
                            id="btnAceptar"
                            className={textAcept != null ? classes.normal : classes.aceptar}
                            onClick={accept}
                            disabled={loading}
                        >
                            {textoAceptar}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
};

export default AvisoConfirmacion;
